module.exports = __webpack_public_path__ + "img/rotate-icon.cd8b676a.svg";